import { SSOLoginPage } from '@features/onboarding/components/login/SSOLoginPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sso-login')({ component: SSOLoginPage });
